import { render, staticRenderFns } from "./UploadPopUp.vue?vue&type=template&id=7820b0a4&scoped=true"
import script from "./UploadPopUp.vue?vue&type=script&lang=js"
export * from "./UploadPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820b0a4",
  null
  
)

export default component.exports